export class TheCryptSoundConfig{
    public static readonly MAIN_GAME_AMBIANCE: string = "background-music-main";
    public static readonly FS_AMBIANCE_1: string = "fs1";
    public static readonly FS_AMBIANCE_2: string = "fs2";
    public static readonly FS_INTRO: string = "fsIntroLoop";

    public static readonly REELS_IN: string = "reelsSpinIn";
    public static readonly REELS_OUT: string = "reelsSpinOut";

    public static readonly REEL_LANDING: string[] = [
        "reelLanding1","reelLanding2","reelLanding3",
        "reelLanding4","reelLanding5","reelLanding6",
        "reelLanding7","reelLanding8","reelLanding9",
        "reelLanding10","reelLanding11"];
    public static readonly ANTICIPATION_LANDING: string = "scatterAnticipationLand01";

    public static readonly WIN_TINY: string = "winTiny";
    public static readonly WIN_SMALL: string = "winSmall";
    public static readonly WIN_MEDIUM: string = "winMedium";
    public static readonly WIN_LARGE: string = "winLarge";

    public static readonly WIN_CAP_MUSIC: string = "capWinMusic";
    public static readonly WIN_CAP_START: string = "capWinStart";
    public static readonly BIGWIN: string[] = ["bigwin1","bigwin2","bigwin3","bigwin4","bigwin5"];
    public static readonly BIGWIN_ENDS: string[] = ["bigwinEnds1","bigwinEnds1","bigwinEnds1","bigwinEnds2","bigwinEnds3"];

    public static readonly XWAYS_LANDING: string[] = ["xwaysLand01","xwaysLand02","xwaysLand03"];

    public static readonly WILD_LANDING: string[] = ["wildLand01","wildLand02","wildLand03","wildLand04"];
    public static readonly WILD_EXPAND: string = "wildNudgeFinal1";
    public static readonly WILD_NUDGE: string[] = ["wildNudge1","wildNudge2","wildNudge3"];
    public static readonly WILD_NUDGE_FINAL: string[] = ["wildNudgeFinal1","wildNudgeFinal2","wildNudgeFinal3","wildNudgeFinal4"];

    public static readonly SCATTER_LANDING: string[] = ["scatterAnticipationLand01","scatterAnticipationLand02","scatterAnticipationLand03"];

    public static readonly FREESPINS_ADD_2: string = "fsPlusSpins";
    public static readonly METER_SHOW: string = "fsMeterToWild";
    public static readonly METER_TO_WILD: string = "fsMeterFull";
    public static readonly METER_LIGHT: string = "fsMeterFill";
    public static readonly SYM_TO_WILD: string = "fsSymToWild";

    public static readonly FREESPIN_OUTRO: string = "fsEnds";

    public static readonly WIN_EXPLOSION_SINGLE: string = "winExplosionSingle";
    public static readonly WIN_EXPLOSION_MULTI: string[] = ["winExplosion01","winExplosion02","winExplosion03","winExplosion04","winExplosion05","winExplosion06"];
    public static readonly WIN_HIGHLIGHT_LOW: string[] = ["winHighlightLow01","winHighlightLow02","winHighlightLow03"];
    public static readonly WIN_HIGHLIGHT_HIGH: string[] = ["winHighlightHigh01","winHighlightHigh02","winHighlightHigh03"];
    public static readonly WIN_HIGHLIGHT_M_SYM: string[] = ["winHighlightHighSym01","winHighlightHighSym02","winHighlightHighSym03"];

    public static readonly COLLECT_SWOOSH: string[] = ["fsMeterWoosh01","fsMeterWoosh02","fsMeterWoosh03","fsMeterWoosh04","fsMeterWoosh05","fsMeterWoosh06"];
    public static readonly CONTINUE_BUTTON: string = "continueButton";
    public static readonly XBET_ON: string = "xbetOn";
    public static readonly XBET_OFF: string = "xbetOff";
    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string = "asWinBig";
}